import { render, staticRenderFns } from "./IpImportPage.vue?vue&type=template&id=c965d148&scoped=true"
import script from "./IpImportPage.vue?vue&type=script&lang=js"
export * from "./IpImportPage.vue?vue&type=script&lang=js"
import style0 from "./IpImportPage.vue?vue&type=style&index=0&id=c965d148&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c965d148",
  null
  
)

export default component.exports